import React from 'react'

import { ArrowLeft } from 'lucide-react'

import { useTranslation } from '@/core/i18n/useTranslation'
import { Button } from '@/shared/components/atoms/Button'

interface PaymentMethodsHeaderProps {
	title: string
	onBack: () => void
	showAddButton?: boolean
	onAddClick?: () => void
}

export const PaymentMethodsHeader: React.FC<PaymentMethodsHeaderProps> = ({
	title,
	onBack,
	showAddButton = false,
	onAddClick,
}) => {
	const { t } = useTranslation('common')

	return (
		<div className="flex items-center justify-between mb-8">
			<div className="flex items-center gap-4">
				<Button
					variant="ghost"
					size="icon"
					onClick={onBack}
					className="h-8 w-8 cursor-pointer"
				>
					<ArrowLeft className="h-4 w-4" />
				</Button>
				<h1 className="text-2xl font-bold text-foreground">{title}</h1>
			</div>
			{showAddButton && onAddClick && (
				<Button onClick={onAddClick} className="cursor-pointer">
					{t('payment_method.add_payment_method')}
				</Button>
			)}
		</div>
	)
}
